/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import {Component, OnInit, ApplicationRef, } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../environments/environment';
import { WindowRef } from './shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {

  env = environment;
  public menu1Opened = false;
  public menu2Opened = false;
  public menu3Opened = false;
  public menu4Opened = false;
  public menu5Opened = false;
  public menu6Opened = false;


  constructor(private translate: TranslateService,private _applicationRef: ApplicationRef) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');
    setInterval(() => {
      this._applicationRef.tick();
    }, 50);
   
  }
  
  ngOnInit() {
  }


}